<template>
  <Box>
    <h2 class="text-t5 mb-3">Beställ underhåll</h2>
    <p>För att beställa underhåll behöver du kontakta oss på Gavlegårdarna.</p>
    <div class="mt-8 rounded-[10px] bg-turquoise-10 p-4">
      <h3 class="text-b3 font-bold uppercase tracking-wider">Kontakta oss</h3>
      <a href="tel:026172700">
        <Button variant="tertiary" size="large">
          026 17 27 00
          <template #icon-before>
            <IconPhone />
          </template>
        </Button>
      </a>
    </div>
  </Box>
</template>

<script>
import Box from '@/components/ui/box'
import Button from '@/components/ui/button'
import IconPhone from '@/components/icons/IconPhone'

export default {
  name: 'OrderMaintenance',
  components: {
    Box,
    Button,
    IconPhone
  }
}
</script>
